var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKopot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 40,
    viewBox: "0 0 223.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044 1748 c-47 -95 -90 -178 -96 -185 -7 -8 -30 -3 -91 19 -210 77 -376 130 -390 125 -22 -8 -59 -112 -65 -181 -6 -78 11 -151 53 -220 33 -55 34 -58 33 -169 0 -159 30 -266 118 -414 12 -21 15 -35 9 -42 -6 -5 -120 -56 -255 -114 -295 -126 -300 -128 -300 -138 0 -4 53 -25 118 -47 333 -114 528 -184 617 -222 158 -67 238 -83 380 -77 98 4 137 10 215 36 155 50 281 139 375 265 116 155 147 257 185 603 16 146 28 159 142 165 37 2 70 7 74 11 4 4 -15 35 -41 69 -27 35 -75 97 -106 138 -88 118 -159 155 -282 148 l-70 -4 -63 -68 c-42 -45 -68 -65 -76 -60 -7 4 -50 38 -95 76 -96 80 -148 153 -234 332 -34 69 -63 126 -65 126 -2 0 -42 -78 -90 -172z m786 -408 c60 -60 -23 -161 -100 -120 -22 12 -42 64 -33 88 19 54 93 72 133 32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKopot);
export default __webpack_public_path__ + "static/media/kopot.2a07d55c4a7c0e9211d90607d8f84227.svg";
export { ForwardRef as ReactComponent };